// components/PoolStats.js
import React from "react";
import usePoolCounts from "../../../hooks/usePoolCounts";
import Tvl from "../../../shared/Tvl";

const PoolStats = ({ rootPoolData, totalTvl }) => {
    // console.log(rootPoolData, 'rootPoolData in stats');
    const {
        rootPoolsCount,
        childPoolsCount,
        loading: countsLoading
    } = usePoolCounts({
        childPoolFilterPool: rootPoolData?.unifarm, // Filter by specific pool
        autoFetch: true
    });
    const formatDuration = (dateString) => {
        if (!dateString) return "N/A";

        const now = Date.now();
        const end = new Date(dateString).getTime(); // convert ISO string to ms

        if (isNaN(end)) return "Invalid Date";
        if (end <= now) return "Expired";

        const diff = end - now;
        const seconds = Math.floor(diff / 1000);
        const days = Math.floor(seconds / (3600 * 24));
        const months = Math.floor(days / 30);
        const years = Math.floor(months / 12);

        if (years > 0) return `${years} Year${years > 1 ? "s" : ""}`;
        if (months > 0) return `${months} Month${months > 1 ? "s" : ""}`;
        if (days > 0) return `${days} Day${days > 1 ? "s" : ""}`;

        const hours = Math.floor(seconds / 3600);
        if (hours > 0) return `${hours} Hour${hours > 1 ? "s" : ""}`;

        const minutes = Math.floor((seconds % 3600) / 60);
        if (minutes > 0) return `${minutes} Minute${minutes > 1 ? "s" : ""}`;

        return `${seconds} Second${seconds > 1 ? "s" : ""}`;
    };


    const stats = [
        { label: "TVL", value: <Tvl contractAddress={rootPoolData?.contractAddress} poolType={"rootPool"} tokenAddress={rootPoolData?.rewardToken}/>},
        { label: "Total Rewards", value: rootPoolData?.rewardAmount || "0" },
        { label: "Total Pools", value: `${rootPoolData?.childPoolCount || "0"} Pools`    },
        { label: "Duration", value: formatDuration(rootPoolData?.poolEndDate) },
    ];

    return (
        <div className="chart_side">
            {stats.map((stat, index) => (
                <div key={index} className="inner_future">
                    <p>{stat.label}</p>
                    <h4>{stat.value}</h4>
                </div>
            ))}
        </div>
    );
};

export default PoolStats;
